import { CsvFileHeaderData, FileMetadata } from '../components/types';

/**
 * Convert CSV file header data from API to FileMetadata format
 * Used for backward compatibility with existing code
 */
export function convertHeaderDataToMetadata(
  headerData: CsvFileHeaderData,
  csvFileSize: number
): FileMetadata {
  return {
    columnCount: headerData.headers.length,
    rowCount: Math.max(headerData.first_10_rows.length, 1), // At least 1 row, or actual count from first_10_rows
    columns: headerData.headers,
    sampleColumns: headerData.headers.slice(0, 10),
    size: csvFileSize,
  };
}

/**
 * Create a SelectedFile from CSV file header data
 * This is used when selecting files from the CSV importer without downloading
 */
export function createSelectedFileFromHeaderData(
  csvFile: { id: number; filename: string; size: number },
  headerData: CsvFileHeaderData
) {
  const metadata = convertHeaderDataToMetadata(headerData, csvFile.size);

  return {
    csvFile: {
      id: csvFile.id,
      filename: csvFile.filename,
      size: csvFile.size,
      // Fill in other required CsvFile fields with defaults
      study_id: 0, // Will be filled from context
      content_type: 'text/csv',
      file_url: '',
      created_at: '',
      updated_at: '',
      user: {
        id: '',
        email: '',
        first_name: '',
        last_name: '',
      },
      last_version_id: csvFile.id,
    },
    headerData,
    source: 'csv-importer' as const,
    validation: {
      isValid: true, // Files from CSV importer are pre-validated
      errors: [],
      warnings: [],
    },
    metadata,
  };
}
